import { useLocation } from "react-router-dom";
import { SITE_URL } from "@/data/site";

const Seo = ({ title, description }) => {
  const { pathname } = useLocation();
  const url = `${SITE_URL}${pathname}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${SITE_URL}/og-image.jpg`} />
    </>
  );
};

export default Seo;
